<template>
  <div class="d-flex align-items-center mb-3">
    <button class="btn btn-white mr-2" type="button" @click="findTransfers()">
      <span v-if="loading">Chargement...</span>
      <span v-else>Rafraîchir</span>
    </button>
    <div v-if="transfers.length">
      <select class="custom-select w-100" name="transfer">
        <option :value="transfer.id" v-for="transfer in transfers" :key="transfer.id">{{ getTransferNumb(transfer.value) }} factures - Soumis le {{ getDate(transfer.created_at) }}</option>
      </select>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import moment from "moment"

export default {
  data () {
    return {
      loading: false,
      transfers: [],
      selected: null
    }
  },

  mounted() {
    this.findTransfers()
  },

  methods: {
    getDate(date) {
      return moment(date).format('DD/MM/yyyy')
    },

    getTransferNumb(val) {
      return val.split(',').length
    },

    findTransfers() {
      this.loading = true

      axios.get(`/webapi/transfers`)
        .then((response) => {
          if (response.data && response.data.transfers) {
            this.transfers = response.data.transfers
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
